import * as React from "react";

function AtIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    role: "img",
    fill: "currentColor",
    className: "anticon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M263.4 16.12c-65.2-2.06-127.2 22.02-174.09 67.55C42.03 129.5 16 191.2 16 257.2c0 118.6 87.89 221.1 204.5 238.5 1.2.2 2.3.3 3.5.3 11.69 0 21.92-8.547 23.7-20.45 1.953-13.11-7.078-25.33-20.19-27.28C134.3 434.3 64 352.2 64 257.2c0-52.94 20.86-102.3 58.73-139.1 37.53-36.41 86.25-55.83 139.2-54.03C364.5 67.2 448 157.9 448 266.3v19.05c0 24.45-19.73 44.36-44 44.36s-44-19.91-44-44.41V168.7c0-13.25-10.75-23.1-24-23.1-11.92 0-21.38 8.855-23.24 20.25C294.4 151.9 272.2 144 248 144c-61.75 0-112 50.25-112 111.1s50.25 111.1 112 111.1c30.75 0 58.62-12.48 78.88-32.62 16.41 25.4 44.77 42.32 77.12 42.32 50.73 0 92-41.44 92-92.36V266.3c0-134.1-104.4-247.2-232.6-250.18zM248 320c-35.3 0-64-28.7-64-63.1 0-35.29 28.7-63.1 64-63.1s64 28.7 64 63.1c0 34.4-28.7 63.1-64 63.1z"
  }));
}

const ForwardRef = React.forwardRef(AtIcon);
export default ForwardRef;